<ion-modal
  #questionnaireNutrigeneticQuickAccessModal
  id="nourish-questionnaire-prompt-modal"
  [backdropDismiss]="false"
  [breakpoints]="[0, 1]"
  [handle]="false"
  [initialBreakpoint]="1"
  [isOpen]="isOpen()"
  (didDismiss)="onDidDismissModal()"
  (willDismiss)="onWillDismissModal($event)"
>
  <ng-template>
    <div class="content">
      <div class="content__header">
        <ion-button
          fill="clear"
          (click)="questionnaireNutrigeneticQuickAccessModal.dismiss()"
        >
          <ion-icon name="chevron-down-outline"></ion-icon>
        </ion-button>
      </div>
      <h1 class="content__title">
        {{ 'nourish.prompt-modal.title' | translate }}
      </h1>
      <div class="content__desc">
        {{ 'nourish.prompt-modal.desc' | translate }}
      </div>

      <div class="content__buttons">
        <ion-button
          color="main-button"
          fill="solid"
          (click)="
            questionnaireNutrigeneticQuickAccessModal.dismiss(null, 'go')
          "
        >
          {{ 'nourish.prompt-modal.answer-button' | translate }}
        </ion-button>
      </div>
    </div>
  </ng-template>
</ion-modal>
